import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { AccountService } from '../../service/data/account.service';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordComponent implements OnDestroy, OnInit {
  constructor(
    private _accountService: AccountService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _messageService: MessageService
  ) {}

  private _mandatoryFields = ['confirmNewPassword', 'newPassword', 'password'];
  private _subscription: Subscription;
  form: FormGroup;

  private _clearForm() {
    this.form.reset();
    this._mandatoryFields.forEach(field => {
      this.form.controls[field].setErrors(null);
    });
  }

  private _createForm() {
    return this._fb.group({
      confirmNewPassword: this._fcf.createMandatory('CHANGE_PASSWORD_FORM.CONFIRM_NEW_PASSWORD_LABEL', ''),
      newPassword: this._fcf.createMandatory('CHANGE_PASSWORD_FORM.NEW_PASSWORD_LABEL', ''),
      password: this._fcf.createMandatory('CHANGE_PASSWORD_FORM.PASSWORD_LABEL', ''),
    });
  }

  private _updateState() {
    this._mandatoryFields.forEach(field => {
      this.form.controls[field].updateValueAndValidity();
    });
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null!;
    }
  }

  ngOnInit() {
    this.form = this._createForm();
  }

  onSubmit() {
    this._updateState();

    if (this.form.controls['newPassword'].value != this.form.controls['confirmNewPassword'].value) {
      this.form.controls['confirmNewPassword'].setErrors({ mismatch: { message: 'ERROR.PASSWORD_MISMATCH_ERROR' } });
      this.form.controls['newPassword'].setErrors({ mismatch: { message: 'ERROR.PASSWORD_MISMATCH_ERROR' } });
      return;
    }

    if (this.form.invalid) return;

    let model = {
      newPassword: this.form.controls['newPassword'].value,
      password: this.form.controls['password'].value,
    };
    this._accountService.changePassword(model).subscribe(
      () => {
        this._clearForm();
        this._messageService.showSuccess();
      },
      error => this._messageService.showError(error)
    );
  }
}
